// extracted by mini-css-extract-plugin
export var dataCell = "_rc-2";
export var dataRow = "_rc-0";
export var headerRow = "_rc-1";